/* ============================================================================
 * eyeoo-facet-panel-scroll.js
 * Progetto: Comelstile (Avante 14.0) — network Eye-oo
 * ----------------------------------------------------------------------------
 * PROBLEMA
 * Nella PLP standard i pannelli faccetta sono dropdown in position:
 * absolute (eyeoo-facets.css, sez. 4 e 12a): non occupano spazio nel
 * flusso, quindi il browser non fa nulla per portarli in vista. Se il
 * chip cliccato sta in basso nel viewport, il pannello si apre sotto il
 * fold e l'utente non vede le opzioni. Su mobile e' la norma, perche' la
 * barra filtri sta sotto banner, descrizione e riga meta.
 *
 * COMPORTAMENTO
 * All'apertura si scorre la pagina:
 *  - pannello che ci sta nello spazio utile -> scroll MINIMO necessario
 *    per portarlo interamente in vista (il chip resta visibile);
 *  - pannello piu' alto dello spazio utile -> bordo superiore appena
 *    sotto l'header, l'eccedenza resta sotto il fold.
 * Lo "spazio utile" e' il viewport meno l'header sticky e i margini.
 *
 * DOCUMENTO TROPPO CORTO
 * Il pannello e' absolute, quindi non allunga il documento: su una
 * collection con pochi prodotti la pagina puo' non avere corsa
 * sufficiente per portarlo in vista. In quel caso si scorre quel che
 * c'e' e si limita l'altezza del pannello allo spazio effettivamente
 * disponibile — ha gia' overflow-y: auto, quindi scorre al suo interno
 * invece di finire fuori schermo. Il limite viene rimosso alla
 * chiusura: nessuno stile residuo.
 *
 * PERCHE' L'HEADER VIENE MISURATO E NON LETTO DA --header-height
 * Su Comelstile quella variabile vale 134px sulle pagine brand e 0px
 * sulle collection e sulla pagina negozi: non e' affidabile come unica
 * fonte. Si misurano gli elementi sticky/fixed realmente ancorati in
 * cima, con --header-height come ripiego.
 *
 * Additivo: nessuna modifica ai file del tema.
 * Caricare da eyeoo-assets.liquid DOPO eyeoo-custom.js, sui soli
 * template collection/search (stesso gate di eyeoo-facets.css).
 * ========================================================================== */

(function () {
  'use strict';

  var CONFIG = {
    enabled: true,

    /* Ambito: solo la barra orizzontale. Il drawer nativo scorre al suo
       interno, dove lo scroll di pagina non serve e sarebbe dannoso. */
    scope: '.snippet-facets--horizontal',
    summarySelector: '.accordion__summary, .mobile-facets__summary',
    panelSelector: '.accordion__panel',

    /* Aria tra pannello e bordi del viewport. */
    margin: 12,

    /* Altezza riservata all'header: 'auto' = misurata, oppure px. */
    headerOffset: 'auto',

    /* Altezza minima sotto cui non si comprime il pannello, anche a
       costo di lasciarlo sbordare: piu' corto di cosi' non e' usabile. */
    minHeight: 180,

    /* Attesa massima per apertura e animazione del pannello. */
    settleTimeout: 400,

    behavior: 'smooth',
    debug: false
  };

  var clamped = [];

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[eyeoo-panel-scroll]'].concat([].slice.call(arguments)));
    }
  }

  function reduceMotion() {
    return !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* --------------------------------------------------------------------
   * Geometria
   * ------------------------------------------------------------------ */

  function headerOffset() {
    if (typeof CONFIG.headerOffset === 'number') return CONFIG.headerOffset;

    var offset = 0;
    var candidates = document.querySelectorAll(
      '[class*="shopify-section-header"], .header-group, header'
    );

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var position = window.getComputedStyle(el).position;
      if (position !== 'sticky' && position !== 'fixed') continue;

      var rect = el.getBoundingClientRect();
      /* Solo elementi effettivamente ancorati in cima: uno sticky non
         ancora agganciato non copre nulla. */
      if (rect.height > 0 && rect.top <= 1) {
        offset = Math.max(offset, rect.bottom);
      }
    }

    if (!offset) {
      var fallback = parseFloat(
        window.getComputedStyle(document.documentElement)
          .getPropertyValue('--header-height')
      );
      if (fallback > 0) offset = fallback;
    }

    return offset;
  }

  /* Pixel ancora percorribili verso il basso. */
  function scrollRoom() {
    var el = document.scrollingElement || document.documentElement;
    return Math.max(0, el.scrollHeight - el.clientHeight - el.scrollTop);
  }

  function bring(panel) {
    var rect = panel.getBoundingClientRect();
    if (!rect.height) return;

    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var topLimit = headerOffset() + CONFIG.margin;
    var bottomLimit = viewport - CONFIG.margin;
    var avail = bottomLimit - topLimit;

    var delta;

    if (rect.height > avail) {
      /* Piu' alto dello spazio utile: bordo superiore sotto l'header,
         eccedenza sotto il fold. */
      delta = rect.top - topLimit;
    } else if (rect.bottom > bottomLimit) {
      /* Sporge in basso: scroll minimo. Il ramo precedente garantisce
         che cosi' il bordo superiore non finisca sotto l'header. */
      delta = rect.bottom - bottomLimit;
    } else if (rect.top < topLimit) {
      /* Coperto dall'header: si torna indietro. */
      delta = rect.top - topLimit;
    } else {
      return; // gia' interamente visibile
    }

    if (Math.abs(delta) < 2) return;

    /* Documento senza corsa sufficiente: si comprime il pannello di
       quanto manca, invece di lasciarlo fuori schermo. */
    if (delta > 0) {
      var room = scrollRoom();
      if (delta > room) {
        var shortfall = delta - room;
        if (rect.height <= avail) {
          var fit = Math.max(rect.height - shortfall, CONFIG.minHeight);
          panel.style.maxHeight = Math.floor(fit) + 'px';
          if (clamped.indexOf(panel) === -1) clamped.push(panel);
          log('documento corto: pannello limitato a', fit);
        }
        delta = room;
      }
    }

    if (Math.abs(delta) < 2) return;

    window.scrollBy({
      top: delta,
      left: 0,
      behavior: reduceMotion() ? 'auto' : CONFIG.behavior
    });
    log('scroll', delta);
  }

  function releaseClamps() {
    while (clamped.length) {
      var panel = clamped.pop();
      if (panel && panel.style) panel.style.maxHeight = '';
    }
  }

  /* --------------------------------------------------------------------
   * Attesa dell'apertura
   * ------------------------------------------------------------------
   * Avante non usa [open] sugli accordion-block dei facet: lo stato e'
   * gestito con classi e altezze. Il test e' quindi agnostico — il
   * pannello e' aperto se occupa spazio — e si attende che l'altezza
   * sia stabile per due frame, cosi' la misura non cade a metа
   * animazione. Se resta a zero (click di chiusura) non si fa nulla.
   * ------------------------------------------------------------------ */

  function whenSettled(panel, done) {
    var last = -1;
    var stable = 0;
    var start = Date.now();

    (function tick() {
      var height = panel.offsetHeight;

      if (height === last) {
        stable++;
      } else {
        stable = 0;
        last = height;
      }

      if (height > 0 && stable >= 2) {
        done();
        return;
      }

      if (Date.now() - start > CONFIG.settleTimeout) {
        if (height > 0) done();
        return;
      }

      window.requestAnimationFrame(tick);
    })();
  }

  /* --------------------------------------------------------------------
   * Aggancio
   * ------------------------------------------------------------------ */

  function onClick(event) {
    if (!CONFIG.enabled) return;

    var target = event.target;
    if (!target || !target.closest) return;

    var summary = target.closest(CONFIG.summarySelector);
    if (!summary) return;

    var block = summary.closest('accordion-block');
    if (!block) return;

    /* I chip booleani applicano il filtro al click e non aprono nulla. */
    if (block.classList.contains('eyeoo-bf')) return;

    if (!block.closest(CONFIG.scope)) return;

    var panel = block.querySelector(CONFIG.panelSelector);
    if (!panel) return;

    releaseClamps();
    whenSettled(panel, function () { bring(panel); });
  }

  function init() {
    /* Fase di bubbling: il tema deve aver gia' aperto il pannello.
       In capture misureremmo un pannello ancora chiuso. */
    document.addEventListener('click', onClick);

    /* Un cambio di viewport invalida il limite di altezza calcolato. */
    window.addEventListener('resize', releaseClamps, { passive: true });
    window.addEventListener('orientationchange', releaseClamps, { passive: true });

    if (window.EYEOO) window.EYEOO.facetPanelScroll = { bring: bring, config: CONFIG };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();